var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.78,29.22H8.218a3.058,3.058,0,0,1-2.9-1.5,3.78,3.78,0,0,1,.276-3.52l6.781-12.96A3.162,3.162,0,0,1,15,9.22a3.162,3.162,0,0,1,2.625,2.023L24.4,24.2a3.78,3.78,0,0,1,.276,3.52A3.057,3.057,0,0,1,21.78,29.22Zm-5.4-4.561a1.283,1.283,0,1,0-1.276,1.409A1.347,1.347,0,0,0,16.383,24.659Zm.034-8.476a1.317,1.317,0,1,0-2.621,0l.31,5.133h0a1.048,1.048,0,0,0,1,1.013,1.036,1.036,0,0,0,.985-.886,1.25,1.25,0,0,0,.012-.127h.009Z",
    transform: "translate(-4.999 -9.22)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningWhite);
export default __webpack_public_path__ + "static/media/warning-white.092b9406363cdb5be660ebad95706390.svg";
export { ForwardRef as ReactComponent };